import client from '../base-api';

const serviceURL = '/holiday';

const holidayService = {

    // General
    getUserDetails(overviewUserId = null) {
        return client.get(`${serviceURL}/user-details/${overviewUserId ? overviewUserId : ''}`);
    },
    getUserHolidays(overviewUserId = null, filterData: any) {
        return client.get(`${serviceURL}/user-holidays/${overviewUserId ? overviewUserId : ''}`, {params: filterData});
    },
    getHolidayDetails(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },

    // Regular holiday
    postRegularHoliday(regularHolidayData: any) {
        return client.post(`${serviceURL}/regular/submit`, regularHolidayData);
    },
    putRegularHoliday(regularHolidayData: any, holidayId: number) {
        return client.post(`${serviceURL}/regular/submit/${holidayId}`, regularHolidayData);
    },
    approveRegularHoliday(holidayId: number, approvedBy: string) {
        return client.put(`${serviceURL}/regular/approve/${holidayId}/${approvedBy}`);
    },

    // Special leave
    postSpecialLeave(specialLeaveData: any) {
        return client.post(`${serviceURL}/special-leave/submit`, specialLeaveData);
    },
    putSpecialLeave(specialLeaveData: any, specialLeaveId: number) {
        return client.post(`${serviceURL}/special-leave/submit/${specialLeaveId}`, specialLeaveData);
    },
    approveSpecialLeave(holidayId: number, approvedBy: string) {
        return client.put(`${serviceURL}/special-leave/approve/${holidayId}/${approvedBy}`);
    },

    // Parental leave
    postParentalLeave(parentalLeaveData: any) {
        return client.post(`${serviceURL}/parental-leave/submit`, parentalLeaveData);
    },
    putParentalLeave(parentalLeaveData: any, parentalLeaveId: number) {
        return client.post(`${serviceURL}/parental-leave/submit/${parentalLeaveId}`, parentalLeaveData);
    },
    approveParentalLeave(holidayId: number, approvedBy: string) {
        return client.put(`${serviceURL}/parental-leave/approve/${holidayId}/${approvedBy}`);
    },


    // Holiday user list
    getUsers(filterData: any) {
        return client.get(`${serviceURL}/user-list`, {params: filterData});
    },

    // Holidays in range
    getOverviewHolidaysInRange(holidayId: number) {
        return client.get(`${serviceURL}/overview/in-range/${holidayId}`);
    },

    // Holiday details
    getOverviewHolidayDetails(holidayId: number) {
        return client.get(`${serviceURL}/details/${holidayId}`);
    },

    // Pending request
    getPendingRequest(filterData: any) {
        return client.get(`${serviceURL}/pending-list`, {params: filterData});
    },
    countPendingRequest() {
        return client.get(`${serviceURL}/count-pending_request-notification`);
    },


    // Decline request
    declineHolidayRequest(id: number) {
        return client.put(`${serviceURL}/overview/decline/${id}`);
    },

    // Delete request
    deleteHolidayRequest(id: number) {
        return client.delete(`${serviceURL}/delete/${id}`);
    }

}

export default holidayService;